import bemBlock from '@gik/core/utils/bemBlock';
import { Button, SidebarSection } from '@gik/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInkind } from '@gik/api/inkinds/inkind';
import { useUserStore } from '@gik/core/store/UserStore';
import { canUserEditPage } from '@gik/inkind-page/utils/inkindPagePermissions';
import { WishlistRows } from '@gik/wishlist-page';
import { inkindPageTourSelectors } from '@gik/inkind-page';

interface IWishlistSectionProps {
  inkindRouteId: string;
}

export default function WishlistSection({ inkindRouteId }: IWishlistSectionProps) {
  const { t } = useTranslation();
  const bem = bemBlock('wishlist-section');

  const { data: inkindPage } = useInkind(inkindRouteId);
  const userStore = useUserStore();
  const userId = userStore.id;

  const giftingUrl = inkindPage?.inkindSituations.length > 0 && inkindPage.inkindSituations[0].giftingUrl;
  const canEdit = canUserEditPage(inkindPage, userId);

  // TODO: extract append to DisableSidebarFeatureButton
  return (
    <SidebarSection
      title="Wishlist"
      className={bem()}
      append={
        canEdit && (
          <Button
            id={inkindPageTourSelectors.addItemsWishlist}
            disabled={!giftingUrl}
            className={bem('button')}
            variant={'secondary'}
            href={giftingUrl || '#'}
          >
            Add Items
          </Button>
        )
      }
    >
      <WishlistRows inkindRouteId={inkindRouteId} />
    </SidebarSection>
  );
}
